import { Card, Form } from "antd";
import React from "react";
import { Signal } from "../../models";

import { Config } from ".";
import {
  EditFormProps,
  SignalSelectorList,
  WidgetTitleFormField,
} from "../../WidgetEditForm";

  function sanitizeInputs(c: Config): Config {
    return {
      title: c.title,
      signals: c.signals.filter((s) => !!s),
      type: "command2",
    };
  }

  const EditForm: React.FC<EditFormProps> = (props) => {
    const commandChatSignals: Signal[] = [];
    const orgCmdPgnSpns: string =  props.assetDetails.orgCmdPgnSpns; 
    //  props.template.signalCollections.map((collection)=>{
    //   if((collection.type) && (collection.type === "Command"))
    //   {
    //       collection.signals.map((signal)=>{
    //         commandChatSignals.push(signal)
    //       });
    //   }
    // });
    props.template.signalCollections.map((collection)=>{
      if(collection.type && collection.type === "none" || collection.type && collection.type === "Command" ){
          collection.signals.filter((signal)=>(signal.format==="text" && 
          (collection.type != "Command" || 
           collection.type === "Command" && orgCmdPgnSpns.indexOf("65305")!==-1))) // this org is supporting command
            .map((signal)=> {
              commandChatSignals.push(signal)
            })
      }
    });

    return (
      <div className="text-widget-edit-form">
        <Form
          onFinish={(values) => props.onFinish(sanitizeInputs(values as Config))}
          layout="vertical"
          form={props.form}
          initialValues={props.config}
        >
          <Card title="Command Chat Widget Settings">
            <WidgetTitleFormField />
            <SignalSelectorList max={10} signals={commandChatSignals} orgCmdPgnSpns={orgCmdPgnSpns} rules= {[]} />
          </Card>
        </Form>
      </div>
    );
  };
  
  export default EditForm;
  